<template>
  <span :style="[imageSize]" :class="{ 'offline_img' : devInfo.CUR_SID !== 2 && devInfo.CUR_SID !== '2' }">
    <v-img v-if="devInfo.DEV_ICON && devInfo.DEV_ICON != ''" style="width:100%;height:100%;" :src="$iconPath + '/' + devInfo.DEV_ICON + '.png' " />
    <v-img v-else style="width:100%;height:100%;" :src="$iconPath + '/' + getDefaultIcon() + '.png'" />
  </span>
</template>

<script>
export default {
  name: 'DeviceIconImage',
  components: {},
  props: {
    devInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    size: {
      type: Number,
      default: 72
    },
    width: {
      type: Number,
      default: 72
    },
    height: {
      type: Number,
      default: 72
    }
  },
  data() {
    return {
      defaultSize: 72
    }
  },
  computed: {
    imageSize() {
      var that = this
      var ret = {
        'width': that.width + 'px',
        'height': that.height + 'px'
      }
      if (that.size !== that.defaultSize) {
        ret = {
          'width': that.size + 'px',
          'height': that.size + 'px'
        }
      }
      return ret
    },
    lineHeight() {
      var that = this
      var ret = {
        'line-height': that.height + 'px'
      }
      if (that.size !== that.defaultSize) {
        ret = {
          'line-height': that.size + 'px'
        }
      }
      return ret
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
    getDefaultIcon() {
      var that = this
      var ret = ''
      if (that.devInfo.PROD_TYPE === 'gateway') {
        ret = 'gateway_v2'
      } else if (that.devInfo.PROD_TYPE === 'process') {
        ret = 'device'
      } else if (that.devInfo.PROD_TYPE === 'ping') {
        ret = 'server'
      } else {
        ret = 'default_device'
      }
      console.log(ret)
      return ret
    }
  }
}
</script>

<style scoped>
.offline_img{
    filter: opacity(70%) grayscale(100%) !important;
   -webkit-filter: opacity(70%) grayscale(100%) !important;
}
.offline_img /deep/ .v-image__image{
    filter: opacity(70%) grayscale(100%) !important;
   -webkit-filter: opacity(70%) grayscale(100%) !important;
 }
</style>
